(function () {
  if (window.__kuruMagnifierAssetInit) return;
window.__kuruMagnifierAssetInit = true;

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM = 2.5;
  var lens = document.createElement('div');
  lens.style.cssText = 'position:fixed;width:180px;height:180px;border-radius:50%;border:2px solid #1A1208;box-shadow:0 4px 16px rgba(0,0,0,.25);pointer-events:none;background-repeat:no-repeat;display:none;z-index:99999;';
  document.body.appendChild(lens);

  var currentSrc = null;

  document.addEventListener('mousemove', function (e) {
    var c = e.target.closest('li.product-media-container') || e.target.closest('.product-media-container');
    if (!c) { lens.style.display = 'none'; return; }

    lens.style.display = 'block';

    var img = c.querySelector('img');
    if (img && img.currentSrc && img.currentSrc !== currentSrc) {
      currentSrc = img.currentSrc;
      lens.style.backgroundImage = 'url(' + currentSrc + ')';
    }

    var r = c.getBoundingClientRect();
    lens.style.left = (e.clientX - 90) + 'px';
    lens.style.top = (e.clientY - 90) + 'px';
    lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
    lens.style.backgroundPosition =
      -((e.clientX - r.left) * ZOOM - 90) + 'px ' +
      -((e.clientY - r.top) * ZOOM - 90) + 'px';
  });
})();